// common-ui/components/CCTimerInput.tsx
import React from 'react';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { hhmmToMin } from '@mummssoftware/utils/timeUtils';
const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  timerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  input: {
    width: 60,
    textAlign: 'center'
  },
  colon: {
    fontSize: 20,
    fontWeight: 600
  }
}));

/**
 * A reusable HH:MM time input component with optional max value logic.
 */
export const CCTimerInput = ({
  label,
  hour,
  minute,
  maxMinutes,
  disabled = false,
  onChange
}) => {
  const classes = useStyles();

  const handleHourChange = e => {
    const h = e.target.value;

    if (maxMinutes == null || hhmmToMin(h || '0', minute) <= maxMinutes) {
      onChange(h, minute);
    }
  };

  const handleMinuteChange = e => {
    const m = e.target.value;

    if (maxMinutes == null || hhmmToMin(hour, m || '0') <= maxMinutes) {
      onChange(hour, m);
    }
  };

  return /*#__PURE__*/React.createElement(Box, {
    className: classes.container
  }, label && /*#__PURE__*/React.createElement(FormHelperText, null, label), /*#__PURE__*/React.createElement(Box, {
    className: classes.timerRow
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "HH",
    variant: "outlined",
    value: hour,
    onChange: handleHourChange,
    inputProps: {
      maxLength: 2,
      style: {
        textAlign: 'center'
      }
    },
    disabled: disabled,
    className: classes.input
  }), /*#__PURE__*/React.createElement(Typography, {
    className: classes.colon
  }, ":"), /*#__PURE__*/React.createElement(TextField, {
    label: "MM",
    variant: "outlined",
    value: minute,
    onChange: handleMinuteChange,
    inputProps: {
      maxLength: 2,
      style: {
        textAlign: 'center'
      }
    },
    disabled: disabled,
    className: classes.input
  })));
};
export default CCTimerInput;